import { DateTime } from "luxon";
import styled from "styled-components";
import tools from "../../../helpers/tools";
import Loader from "../Loader";
import { TooltipButton } from "../Tooltip/Tooltip";

const StyledDate = styled.p`
  font-weight: 200;
  text-align: center;
  font-size: 12px;
`;

const FileItem = ({ doc, onDownload, isDownloading }) => {
  const hasFile = doc.fileName;

  return (
    <StyledDocumentItem className="shadow-sm border">
      <StyledDate>
        {hasFile ? (
          <>
            Envoyé le <strong>{tools.formatDate(doc.uploadedAt)}</strong>
          </>
        ) : (
          "Non envoyé"
        )}
      </StyledDate>
      <div className="doc__name">{doc.fileType.name}</div>

      {doc.fileName && (
        <>
          <div className="d-flex justify-content-center">
            <div
              className="d-flex flex-row justify-content-center w-100"
              style={{
                gap: "10px",
              }}
            >
              <button
                className="btn btn-default text-primary rounded-pill border "
                onClick={() => onDownload(doc, true)}
                disabled={isDownloading}
                title="Voir"
              >
                {isDownloading ? (
                  <Loader size={22} />
                ) : (
                  <i className="fa fa-eye text-primary" />
                )}
              </button>

              <button
                className="btn btn-primary  rounded-pill border "
                onClick={() => onDownload(doc)}
                disabled={isDownloading}
                title="Télécharger"
              >
                {isDownloading ? (
                  <Loader size={22} />
                ) : (
                  <i className="fa fa-cloud-download-alt fa-lg" />
                )}
              </button>
            </div>
          </div>
        </>
      )}
    </StyledDocumentItem>
  );
};

const StyledDocumentList = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  max-width: 100%;
  overflow-y: scroll;
  padding: 10px 0px;
`;

const StyledDocumentItem = styled.div`
  width: 170px;
  height: 230px;
  padding: 10px;
  border-radius: 20px;
  background: white;
  margin-right: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & .doc__name {
    font-size: var(--font-size-default);
    text-align: center;
    margin-top: -15px;
    /* font-weight: 400;
    letter-spacing: 1.1px; */
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
  }

  & .doc__date {
    font-weight: 200;
    /* margin-top: 15px; */
    text-align: center;
    font-size: 12px;
  }
`;

export default FileItem;
